<template>
  <div class="flex mb-6 items-center border-b-2">
    <div class="flex-grow flex items-center">
      <template
        v-for="crumb, i in crumbs"
        :key="'breadcrumb-' + i"
      >
        <RouterLink
          v-if="crumb.link"
          :to="crumb.link"
          class="underline"
        >
          {{ crumb.label }}
        </RouterLink>
        <h1
          v-else
          class="text-xl font-bold"
        >
          {{ crumb.label }}
        </h1>
        <ChevronRightIcon
          v-if="i < crumbs.length - 1"
          class="h-4 w-4 mx-2"
        />
      </template>
    </div>
    <div class="right">
      <slot />
    </div>
  </div>
</template>

<script setup>
import {
  ChevronRightIcon,
} from "@heroicons/vue/24/outline";

defineProps({
  crumbs: {
    type: Array,
    required: true
  }
})
</script>